<template>
  <a-layout class="app-layout">
    <a-layout-header class="app-header">
      <div class="header-content">
        <div class="logo">Outscraper Export Tool</div>
        <div class="user-section" v-if="authStore.user">
          <a-dropdown>
            <a-button type="text" class="user-button">
              {{ authStore.user.full_name }}
              <DownOutlined />
            </a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item @click="handleChangePassword">
                  <LockOutlined />
                  Change Password
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item @click="handleLogout">
                  <LogoutOutlined />
                  Logout
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </a-layout-header>
    <a-layout-content class="app-content">
      <router-view />
    </a-layout-content>
  </a-layout>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { DownOutlined, LogoutOutlined, LockOutlined } from '@ant-design/icons-vue'

const authStore = useAuthStore()
const router = useRouter()

const handleChangePassword = () => {
  router.push('/change-password')
}

const handleLogout = () => {
  authStore.logout()
  router.push('/login')
}
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
}

.app-header {
  background: #fff;
  padding: 0 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  font-size: 18px;
  font-weight: 600;
  color: #1890ff;
}

.user-button {
  font-size: 14px;
}

.app-content {
  background: #f5f5f5;
  padding: 24px;
}
</style>
